import { render, staticRenderFns } from "./ratingModal.vue?vue&type=template&id=5b560b2a&scoped=true"
import script from "./ratingModal.vue?vue&type=script&lang=js"
export * from "./ratingModal.vue?vue&type=script&lang=js"
import style0 from "./ratingModal.vue?vue&type=style&index=0&id=5b560b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b560b2a",
  null
  
)

export default component.exports